<template>
  <div id="ceremonie" v-if="ceremonies">
    <div id="cYear" v-for="(ceremonie, index) in ceremonies.ceremonies" :key="`c${index}`">
      <div class="upper" id="mission">
        <div class="title" v-html="ceremonie.title"></div>
      </div>

      <div class="block" v-html="ceremonie.subtitle"></div>

      <div class="cerVidOuter" ref="cerVidOuter">
        <div class="cerVid">
          <div class="embed-container link">
            <iframe :src="ceremonie.youtube" frameborder="0" allowfullscreen v-if="ceremonie.youtube"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      vw: 0,
      rs: false
    }
  },

  computed: {
    ceremonies () {
      return this.$store.getters.ceremonies
    }
  },

  mounted () {
    this.$root.$emit('scrollAfterEnter')
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

#ceremonie {
  padding: 0 $side;
  overflow: auto;

  .block {
    text-align: center;
    padding-bottom: $unit;
  }
}

#cYear {
  // display: flex;
  // flex-direction: column;
  margin-bottom: 10rem;
  // height: calc(var(--vh, 1vh) * 100 - 10rem);
}

.hideEdge {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  outline: 2px solid white !important;
  outline-offset: -1px;
  pointer-events: none;
}

.embed-container.responsive {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.cerVidOuter {
  width: 100%;
  position: relative;
  flex: 1;
}

.cerVid {
  // position: absolute;
  // width: 100%;
  // height: 100%;
}

.embed-container {
  // aspect-ratio: 16 / 9;
  // max-height: 100%;
  position: relative;
  margin: 0 auto;
  background-color: black;
  position: relative;
  // top: 50%;
  // transform: translate(0, -50%);
  padding-bottom: 56.25%;
  // max-height: 50vh;
}

@media screen and (max-width: $breakPoint1) {
  #cYear {
    margin-bottom: 5rem;
    height: calc(var(--vh, 1vh) * 60 - 10rem);
  }

  .embed-container {
    top: 0;
    transform: none;
  }
}
</style>
